<template>
  <b-card
    no-body
    class="card-browser-states equal-height-card"
  >
    <b-card-header>
      <div>
        <b-card-title class="chart-title">
          Delivered / Failed</b-card-title>
        <b-card-text class="font-small-2" />
      </div>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        size="sm"
        variant="outline-primary"
        class="widgetrefresh-button d-sm-flex align-items-center justify-content-center shadow-custom"
        :style="cardBorder"
        @click="refreshWidget"
      >
        <feather-icon
          icon="RefreshCwIcon"
          class="mr-50 refresh-icon"
        />
        <span class="align-middle refresh-span" />
        <time-ago
          :datetime="lastUpdatedAt"
          refresh
          locale="en"
          :long="true"
          :style="{color: '#1C1F32'}"
        />
      </b-button>
    </b-card-header>

    <!-- body -->
    <b-card-body class="d-flex justify-content-center align-items-center mb-2 mr-0 chart-body">
      <vue-apex-charts
        :width="chartWidth"
        :options="chartOptions"
        :series="data.series"
        type="donut"
      />
    </b-card-body>
    <!--/ body -->
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BButton,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { TimeAgo } from 'vue2-timeago'
import RefreshMixin from '@/@core/mixins/ui/refresh'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    VueApexCharts,
    TimeAgo,
    BButton,
  },
  mixins: [RefreshMixin],
  props: {
    data: {
      type: Object,
      default: () => [],
    },
    lastUpdatedAt: {
      type: String,
      default: null,
    },
    queue: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: 'donut',
          stacked: false,
          sparkline: {
            enabled: false,
          },
          animations: {
            enabled: true,
          },
        },
        labels: ['Delivered', 'Not Delivered'],
        colors: ['#cbeccb', '#ebc4c4'],
        dataLabels: {
          enabled: false, //  Hides the percentage inside the chart slices
        },
        states: {
          hover: {
            filter: {
              type: 'none',
              value: 0,
            },
          },
          active: {
            filter: {
              type: 'none',
              value: 0,
            },
          },
        },
        stroke: {
          show: true,
          width: 0,
        },
        legend: {
          position: 'right',
          offsetY: 55,
          formatter(seriesName, opts) {
            const { series } = opts.w.config
            const total = series.reduce((a, b) => a + b, 0)
            const index = opts.seriesIndex
            const value = series[index]
            const percent = total ? ((value / total) * 100).toFixed(1) : 0
            return `${seriesName} - ${percent}%`
          },
        },
        responsive: [
          {
            breakpoint: 991, // for tablet,mobile screens
            options: {
              chart: {
                width: 300,
              },
              legend: {
                position: 'bottom',
                offsetY: 0,
              },
            },
          },
        ],
      },
      chartWidth: 485,
    }
  },
  computed: {
    cardBorder() {
      return {
        border: '1px solid var(--primary) !important',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../@core/scss/vue/pages/widget-refresh.scss';

.equal-height-card {
  min-height: 408px;
  display: flex;
  flex-direction: column;
  overflow: visible !important;
  position: relative;
  z-index: 10;
}

.card-browser-states {
  overflow: visible !important;
}

.chart-body {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: visible !important;
  position: relative;
  z-index: 10;
  padding: 20px;
}

::v-deep .apexcharts-tooltip {
  z-index: 9999 !important;
}

.refresh-icon {
  color: #1C1F32;
}
</style>
